"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  "基隆市": 1,
  "台北市": 2,
  "新北市": 3,
  "桃園市": 4,
  "新竹市": 5,
  "新竹縣": 6,
  "苗栗縣": 7,
  "台中市": 8,
  "彰化縣": 9,
  "南投縣": 10,
  "雲林縣": 11,
  "嘉義市": 12,
  "嘉義縣": 13,
  "台南市": 14,
  "高雄市": 15,
  "屏東縣": 16,
  "台東縣": 17,
  "花蓮縣": 18,
  "宜蘭縣": 19,
  "澎湖縣": 20,
  "金門縣": 21,
  "連江縣": 22
};
exports.default = _default;